import { useEffect, useLayoutEffect, useState } from "react";

const useEnhancedEffect =
  typeof window !== "undefined" && process.env.NODE_ENV !== "test"
    ? useLayoutEffect
    : useEffect;

interface NoSSRProps {
  children: React.ReactElement;
  defer?: boolean;
  fallback?: React.ReactElement | null;
}

const NoSSR = ({
  children,
  defer = false,
  fallback = null,
}: NoSSRProps): React.ReactElement | null => {
  const [isMounted, setMountedState] = useState(false);

  useEnhancedEffect(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);

  useEffect(() => {
    if (defer) {
      // defer 모드는 layout 아닌 일반 effect 타이밍으로 마운트 게이트를 여는 계약 —
      // useSyncExternalStore로 대체 시 타이밍 구분이 사라지므로 유지.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setMountedState(true);
    }
  }, [defer]);

  return isMounted ? children : fallback;
};

export default NoSSR;
